import api, { checkTokenErrorResponse } from '..';

const tipos_periodo = [
    ["S", 'Semanal'],
    ["Q", 'Quinzenal'],
    ["M", 'Mensal']
];

export async function postEnrollment(studentId, data_inicio, periodo_pagamento, parcelas_totais, documento, nome_documento, valor, desconto, bolsa) {
    const formdata = new FormData();
    formdata.append("data_inicio", data_inicio);
    formdata.append("periodo_pagamento", periodo_pagamento);
    formdata.append("parcelas_totais", parcelas_totais);
    formdata.append("nome", nome_documento);
    formdata.append("valor", valor);
    formdata.append("desconto", desconto);
    formdata.append("bolsa", bolsa);
    if(documento)
        formdata.append("documento", documento);

    return api.post(`alunos/${studentId}/matriculas/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getEnrollments(studentId) {
    return api.get(`alunos/${studentId}/matriculas/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getEnrollment(studentId, enrollmentId) {
    return api.get(`alunos/${studentId}/matriculas/${enrollmentId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function deleteEnrollment(studentId, enrollmentId) {
    return api.delete(`alunos/${studentId}/matriculas/${enrollmentId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function postPayment(studentId, enrollmentId, documento = null, data = null) {
    const formdata = new FormData();
    if(documento !== null && documento !== '')
        formdata.append("documento", documento);
    if(data) formdata.append("data", data);

    console.log(formdata);

    return api.post(`alunos/${studentId}/matriculas/${enrollmentId}/pagamentos/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getPayments(studentId, enrollmentId) {
    return api.get(`alunos/${studentId}/matriculas/${enrollmentId}/pagamentos/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getFinancialReport(classId, year, month) {
    return api.get(`/turmas/${classId}/relatorio_financeiro/?ano=${Number(year)}&mes=${Number(month)}`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}


const paymentServices = {
    postEnrollment,
    getEnrollments,
    getEnrollment,
    deleteEnrollment,
    postPayment,
    getPayments,
    getFinancialReport,
    tipos_periodo
}
export default paymentServices;